import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {from, Observable, of, switchMap} from 'rxjs';
import {ClerkService} from 'ngx-clerk';
import {take, catchError} from 'rxjs/operators';
import {AppCheck} from '../../helpers/app-check/app-check';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private clerk: ClerkService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isAppCheckTarget =
      req.url.includes('/api/') ||
      req.url.includes('sign.mt/api') ||
      req.url.includes('cloudfunctions.net') ||
      req.url.includes('sign-mt/us-central1');

    if (isAppCheckTarget) {
      return from(AppCheck.getToken()).pipe(
        catchError(err => {
          console.warn('AppCheck token acquisition failed, proceeding without it:', err);
          return of(null);
        }),
        switchMap(token => {
          let headers = req.headers;
          if (token) {
            headers = headers.set('X-Firebase-AppCheck', token).set('X-AppCheck-Token', token);
          }

          const isInternalApi = req.url.includes('/api/v1/') || req.url.includes('localhost:3000'); // Example internal paths

          if (isInternalApi) {
            return this.clerk.session$.pipe(
              take(1),
              switchMap(session => {
                if (session && typeof session.getToken === 'function') {
                  return from(session.getToken()).pipe(
                    switchMap(clerkToken => {
                      if (clerkToken) {
                        headers = headers.set('Authorization', `Bearer ${clerkToken}`);
                      }
                      return next.handle(req.clone({headers}));
                    }),
                    catchError(() => next.handle(req.clone({headers})))
                  );
                }
                return next.handle(req.clone({headers}));
              })
            );
          }

          return next.handle(req.clone({headers}));
        })
      );
    }

    return next.handle(req);
  }
}
